<template>
  <TabbedBox :useQueryNavigation="true">
    <template v-slot:tablist>
      <Tab :first="true" tabid="tab-panel-list">
        <i class="far fa-list"></i> Recut Panel List
      </Tab>
    </template>
    <template v-slot:tabcontent>
      <TabPage :first="true" tabid="tab-panel-list">
        <DataTable
          ref="dataTable"
          :columns="columnList"
          defaultColumnOrderDir="DESC"
          :defaultColumnOrderIndex="4"
          :url="dataURL"
          :filterOptions="panelFilterOptions"
          :displayTools="true"
          :hasDateRangeFilter="true"
          :displayExportTools="true"
          :useReportingServer="true"
          exportTitle="Recut Panels"
          :debounceTime="300"
        >
          <template v-slot:title>
            <slot name="title" />
          </template>
          <template v-slot:tools>
            <slot name="tools" />
          </template>
          <template v-slot:row="row">
            <tr :key="row.data.id">
              <td class="table-data-nav-link">
                <LinkProductionPanel :id="row.data.id" :name="row.data.barcode" />
              </td>
              <td>{{row.data.panelHeight}} x {{row.data.panelWidth}}</td>
              <td>
                <LinkUser :id="row.data.recutUserId" :name="row.data.recutUserName" />
              </td>
              <td>
                {{row.data.recutReportingUser}}
              </td>
              <td>
                {{row.data.recutNotes}}
              </td>
              <td>
                {{formatDateTime(row.data.recutDate)}}
              </td>
              <td>
                <LinkStock :id="row.data.stockId" :name="row.data.stockName" />
              </td>
              <td>
                <LinkOrder :id="row.data.orderId" :name="row.data.orderSequenceNumber" />
              </td>
              <td>
                <LinkContact :id="row.data.orderContactId" :name="row.data.orderContactName" />
              </td>
              <td>
                <LabelTags :labelList="row.data.labelList" />
              </td>
              <td>
                {{formatCurrency(row.data.totalProcessingValue)}}
              </td>
              
            </tr>
          </template>
          <template v-slot:summary="summary">
            <tr key="summary">
              <td>Totals</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>{{summary.data.totalPanelProcessingValue | formatCurrency}}</td>
            </tr>
          </template>
        </DataTable>
        
      </TabPage>
    </template>
  </TabbedBox>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import buildUrl from 'build-url'
import { mapState } from 'vuex'

import Utils from '@/utils/utils'

export default {
  name: 'RecutValue',
  components: {
  },
  data() {
    return {
      columnList: [
        { title: "Barcode", data: "id" },
        { title: "Size", data: "size" },
        { title: "Logged User", data: "recutUserName" },
        { title: "Reporting User", data: "recutReportingUser" },
        { title: "Notes", data: "recutNotes" },
        { title: "Recut Date", data: "recutDate", dateFilter: true, type: 'datetime' },
        { title: "Stock", data: "stockName" },
        { title: "Order", data: "orderSequenceNumber" },
        { title: "Customer", data: "orderContactName" },        
        { title: "Labels", data: "labelListNames", type: 'label' },
        { title: "Processing Value", data: "totalProcessingValue", type: 'currency', totalField: 'totalPanelProcessingValue' }
      ]
    }
  },
  computed: {
    dataURL() {
      var params = {
        filter: {},
        includesummary: true
      }      

      return '/intelligence/production/recutvalue/panels?' + $.param(params)
    },
    panelFilterOptions() {
      var filterOptions = [
      ]

      let recutLabels = this.$store.getters['label/getLabelsByType']('productionPanelRecut')
      filterOptions.push({
        name: 'Recut Label',
        field: 'labelListNames',
        operator: 'like',
        options: recutLabels.reverse().map(labelInfo => {
          return {
            name: labelInfo.name,
            value: '%' + labelInfo.name + '%',
            colour: labelInfo.colour
          }
        })
      })

      return filterOptions
    }
  },
  mounted() {
    this.requestFilterLabels()
    
  },
  beforeDestroy() {
  },
  methods: {
    requestFilterLabels() {
      return new Promise(async (resolve, reject) => {
        try {
          // Get the label info for the filter popovers
          let recutLabels = await this.$apiService.coreService.getLabelsForType('productionPanelRecut')
          this.$store.commit({
            type: 'label/updateLabels',
            labelType: 'productionPanelRecut',
            labelList: recutLabels.data
          })

          return resolve()
        } catch(err) {
          return reject(err)
        }
      })      
    }
    
  }
}
</script>
